import TagManager from 'react-gtm-module'

import { ActiveCountryId } from '../constants'
import { Locale } from '../../external'

const setDatalayerPlatformLocale = (country: ActiveCountryId, language: Locale) => {
  TagManager.dataLayer({
    dataLayer: {
      platform_country: country.toLowerCase(),
      platform_language: language.toLowerCase(),
    },
  })
}

export default setDatalayerPlatformLocale
